import { getDigits } from "./getDigits.util";
import { regexs } from "./regexs.util";

const sanitizeDocument = (value: string = "") => value.replace(/[.\-\/\s]/g, "").toUpperCase().trim();

const cpfMask = (value: string) => {
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
  value = value.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
  //de novo (para o segundo bloco de números)
  value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
  return value;
};

const cepMask = (value: string) => {
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/(\d{5})(\d)/, "$1-$2");
  return value;
};

const phoneMask = (value: string) => {
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.slice(0, 11); // Limita os dígitos
  value = value.replace(/(\d{2})(\d)/, "($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
  value = value.replace(/(\d)(\d{4})$/, "$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos
  return value;
};

//  Usecases
export const validateCPForCNPJ = (value: string) => regexs.CPJ_AND_CNPJ_REGEX.test(value);

export const validateCEP = (value: string) => regexs.CEP_REGEX.test(value);

export const formatCPF = (value: string) => {
  const cleanValue = getDigits(value);
  return cpfMask(cleanValue.slice(0, 11));
};

export const formatCNPJ = (value: string) => {
  const normalized = sanitizeDocument(value).replace(/[^A-Z0-9]/g, "");
  const base = normalized.slice(0, 12);
  const verifierDigits = normalized.slice(12).replace(/\D/g, "").slice(0, 2);
  const merged = `${base}${verifierDigits}`;

  let formatted = "";
  for (let i = 0; i < merged.length; i++) {
    if (i === 2 || i === 5) formatted += ".";
    if (i === 8) formatted += "/";
    if (i === 12) formatted += "-";
    formatted += merged[i];
  }

  return formatted;
};

export const formatCPForCNPJ = (value: string) => {
  const normalized = sanitizeDocument(value);
  if (normalized.length <= 11 && /^\d*$/.test(normalized)) return formatCPF(value);
  return formatCNPJ(value);
};

export const formatCep = (value: string) => cepMask(getDigits(value).slice(0, 8));

export const formatPhone = (value: string) => phoneMask(value);

export const normalizeDocumentForApi = (value: string = "") => sanitizeDocument(value);
